module.exports = __webpack_public_path__ + "static/img/262.87122d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/262.jpg
// module id = 6CF3
// module chunks = 0